import React from 'react';
import $ from 'jquery';

import AUFDisciplines from './AUFDisciplinesComponent';
import AUFDegrees from './aUFDegreesComponent';
import AUFClassifications from './aUFClassificationsComponent';
import AUFOfferings from './aUFOfferingsComponent';

import { $scrollTo } from './../../mixin/mixin-jquery';

class AUFilter extends React.Component {
  constructor() {
    super();

    this._handleReset = this._handleReset.bind(this);
    this._$scrollTo = $scrollTo;
  }

  componentDidMount() {
    /* Bind events - jQuery */
    this._$scrollTo($('.widget.unit-filter .btn-submit'), $('.all-units-wrap'));
  }

  render() {
    let total = this.props.count;
    let resultMsg = total === 0 ? 'No ' +this.props.searchResultName+' found' : '<strong>' + total + '</strong> '+this.props.searchResultName+' found';
        resultMsg += '<br/><span>Add or remove selections above to update list<span>';
        
    return <div className="widget unit-filter">
      <div className="widget-inner">
        <h3>Filter by discipline</h3>
        <form action="" method="POST" noValidate="novalidate">

            <label htmlFor="query-degree-name" className="visuallyhidden">Search</label>

            <AUFDisciplines disciplines={this.props.disciplines}
                            currDisciplines={this.props.currDisciplines}
                            placeholderText='select disciplines/s'
                            dispatchReducer={this.props.dispatchReducer} />

            <AUFDegrees avaiDegrees={this.props.avaiDegrees}
                        currDegrees={this.props.currDegrees}
                        placeholderText={this.props.isDegreeDisabled===true ? "select a discipline first":"select degree/s"}
                        isDegreeDisabled={this.props.isDegreeDisabled}
                        dispatchReducer={this.props.dispatchReducer} />

            <AUFClassifications classifications={this.props.classifications}
                                currClassification={this.props.currClassification}
                                dispatchReducer={this.props.dispatchReducer} />

            <AUFOfferings offerings={this.props.offerings}
                          currOffering={this.props.currOffering}
                          dispatchReducer={this.props.dispatchReducer} />

            <div className="sq-form-control clearfix">
            { this.props.initLoad ? null :
                  <p className="result-msg" dangerouslySetInnerHTML={{__html: resultMsg}} /> }
            </div>

            <div className="sq-form-control clearfix">
              <button type="Reset"
                     className="button type-3 btn-reset"
                     onClick={this._handleReset}>
                     RESET FILTER
              </button>

              <button type="Submit"
                     name="form_email_148635_submit"
                     className="button type-2 btn-submit"
                     id="form_email_148635_submit">
                     View Results
              </button>
            </div>
        </form>
      </div>
    </div>;
  }

  _handleReset(e) {
    e.preventDefault();

    let action = {
      type:       'ALL_UNITS::RESET',
      fireFilter: true
    };
    this.props.dispatchReducer(action);
  }
}

AUFilter.propTypes = {
  disciplines:     React.PropTypes.array.isRequired,
  degrees:         React.PropTypes.array.isRequired,
  classifications: React.PropTypes.array.isRequired,
  offerings:       React.PropTypes.array.isRequired,

  avaiDegrees: React.PropTypes.array.isRequired,

  currOffering:       React.PropTypes.array.isRequired,
  currDisciplines:    React.PropTypes.array.isRequired,
  currDegrees:        React.PropTypes.array.isRequired,
  currClassification: React.PropTypes.string.isRequired,

  initLoad:         React.PropTypes.bool.isRequired,
  count:            React.PropTypes.number.isRequired,
  isDegreeDisabled: React.PropTypes.bool.isRequired,

  placeholderText:  React.PropTypes.string.isRequired,
  searchResultName: React.PropTypes.string.isRequired,

  dispatchReducer: React.PropTypes.func.isRequired
};

export default AUFilter;
